import {
  AppstoreAddOutlined,
  KeyOutlined,
  NotificationOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Col, Layout, Menu, Row } from "antd";
import { useRef, useState } from "react";
import GeneralInfoes from "./Components.tsx/GeneralInfoes";
import Allows from "./Components.tsx/Allows";
import ChangePassword from "./Components.tsx/ChangePassword";
import PackageManagementIndex from "./Components.tsx/Package/PackageManagementIndex";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";

const MenuIndex = () => {
  const {  Content } = Layout;
  const [selectedKey, setSelectedKey] = useState<any>("profile");
  const {userInfoes }= useSelector((state:RootState)=>state.profile)
  const containerRef = useRef(null)
  const items = [
    {
      key: "profile",
      label: "Profil",
      icon: <UserOutlined />,
    },
    {
      key: "changePassword",
      label: "Şifre Değiştirme",
      icon: <KeyOutlined />,
    },

    {
      key: "allows",
      label: "Bildirimler & İzinler",
      icon: <NotificationOutlined />,
    },
   ...(userInfoes?.userType!==3?[
    {
      key: "package",
      label: "Üyeliğim",
      icon: <AppstoreAddOutlined/>,
    },
   ]:[])
  ];

  return (
    <Col span={24} className="!p-0" >
      <Row 
       gutter={[
        { xs: 10, md:10 , xl:10 }, 
        { xs:10 , md: 15, xl:20}   
      ]}
      className="xl:!h-screen !bg-white" ref={containerRef}  >
      <Col xs={24}   xl={6} xxl={4} className="!rounded-lg ">
      
        <ResponsiveMenu
        
          containerRef={containerRef}
            currentStep={selectedKey}
            setCurrentStep={setSelectedKey}
            defaultSelectedKeys={["0"]}
            menuItems={items}
            onClick={(e) => setSelectedKey(e.key)}
          />
          
          

      </Col>
      <Col xs={24}  xl={18} xxl={20} className="  ">
        <Content className="!bg-white ">
          {(() => {
            if (selectedKey === "profile") {
              return (
                <>
                  <GeneralInfoes />
                </>
              );
            } else if (selectedKey === "changePassword") {
              return (
                <>
                  <ChangePassword />
                </>
              );
            } else if (selectedKey === "allows") {
              return (
                <>
                  <Allows />
                </>
              );
            } else if (selectedKey === "package"&&userInfoes?.userType!==3) {
              return (
                <>
                  <PackageManagementIndex/>
                </>
              );
            }

            return <></>;
          })()}
        </Content>
      </Col>
      </Row>
      
    </Col>
  );
};

export default MenuIndex;
